import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { IUserBasicInfo } from "../../models/storeModels/IUserBasicInfo";
import { logout } from "../../features/auth";

const initialState: IUserBasicInfo = {
    UserId: undefined,
    Login: null,
    Description: null,
    OrganizationID: null,
    OrganizationName: null,
    DepartmentID: null,
    DepartmentName: null,
    Position: null,
    CanViewAllData: undefined,
    Email: null,
    Phone: null,
}

export const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {
        changeUserInfo(state, action: PayloadAction<IUserBasicInfo>) {
            state = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return initialState
        })
    },
})

export const { changeUserInfo } = userInfoSlice.actions
export const userInfoReducer = userInfoSlice.reducer;
